import script from "./BaseTemplateContentShape.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateContentShape.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateContentShape.vue?vue&type=style&index=0&id=7e123086&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e123086"]])

export default __exports__